<template>
<div>
    <h3 class="text-center" style="text-transform: uppercase">Hóa đơn trả cọc</h3>
    <table class="mx-auto">
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Số phòng</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.room_id }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Ngày ra</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.date_out.substr(0, 10) }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Số ngày</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.date_count }}</td>
        </tr>
        <tr>
            <td class="font-weight-bold" colspan="2">
                Tiền phòng
            </td>
        </tr>
        <tr>
            <td class="text-left">Đơn giá</td>
            <td class="text-right">{{ bill.room_price | formatNumber }}</td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">{{ bill.room_bill | formatNumber }}</td>
        </tr>
        <tr>
            <td class="font-weight-bold" colspan="2">
                Tiền điện
            </td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">Đơn giá</td>
            <td class="text-right text-no-wrap">{{ bill.electric_price | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Đầu kỳ</td>
            <td class="text-right text-no-wrap">{{ bill.electric.start | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Cuối kỳ</td>
            <td class="text-right text-no-wrap">{{ bill.electric.end | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Tiêu thụ</td>
            <td class="text-right text-no-wrap">{{ (bill.electric.end - bill.electric.start) | formatNumber }}</td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">{{ bill.electric.total_bill | formatNumber }}</td>
        </tr>
        <tr>
            <td class="font-weight-bold" colspan="2">
                Tiền nước
            </td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">Đơn giá</td>
            <td class="text-right text-no-wrap">{{ bill.water_price | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Đầu kỳ</td>
            <td class="text-right text-no-wrap">{{ bill.water.start | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Cuối kỳ</td>
            <td class="text-right text-no-wrap">{{ bill.water.end | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap">-- Tiêu thụ</td>
            <td class="text-right text-no-wrap">{{ (bill.water.end - bill.water.start) | formatNumber }}</td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">{{ bill.water.total_bill | formatNumber }}</td>
        </tr>
        <tr>
            <td class="font-weight-bold">
                Tiền rác và vệ sinh
            </td>
            <td class="text-right text-no-wrap">
                {{ bill.trash_bill | formatNumber }}
            </td>
        </tr>
        <!-- <tr>
            <td class="font-weight-bold" colspan="2">
                Tiền xe
            </td>
        </tr>
        <tr>
            <td class="text-left">Đơn giá xe máy</td>
            <td class="text-right">{{ bill.motorbike_price | formatNumber }}</td>
        </tr>
        <tr>
            <td class="text-left">Đơn giá xe đạp</td>
            <td class="text-right">{{ bill.bike_price | formatNumber }}</td>
        </tr>
        <tr
            v-for="(device, index) in bill.motorbike.data"
            :key="'motorbike' + index"
        >
            <td class="text-left">-- {{ device.name }}</td>
            <td class="text-right">{{ device.date_count }} ngày</td>
        </tr>
        <tr
            v-for="(device, index) in bill.bike.data"
            :key="'bike' + index"
        >
            <td class="text-left">-- {{ device.name + (index + 1) }}</td>
            <td class="text-right">{{ device.date_count }} ngày</td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap">Thành tiền</td>
            <td class="text-right text-no-wrap">{{ bill.motorbike.total_bill + bill.bike.total_bill | formatNumber }}</td>
        </tr> -->
        <tr>
            <td class="font-weight-bold">
                Tiền xe
            </td>
            <td class="text-right text-no-wrap">
                {{
                    (bill.motorbike.total_bill + bill.bike.total_bill)
                        | formatNumber
                }}
            </td>
        </tr>
        <template v-if="bill.washing_machine && bill.washing_machine.total_bill">
            <tr>
                <td class="font-weight-bold" colspan="2">
                    Tiền máy giặt
                </td>
            </tr>
            <tr>
                <td class="text-left">Đơn giá</td>
                <td class="text-right">{{ bill.washing_machine_price | formatNumber }}</td>
            </tr>
            <tr class="font-weight-bold">
                <td class="text-left text-no-wrap">Thành tiền</td>
                <td class="text-right text-no-wrap">{{ bill.washing_machine.total_bill | formatNumber }}</td>
            </tr>
        </template>
        <template v-if="bill.air_conditioner && bill.air_conditioner.total_bill">
            <tr>
                <td class="font-weight-bold" colspan="2">
                    Tiền máy lạnh
                </td>
            </tr>
            <tr>
                <td class="text-left">Đơn giá</td>
                <td class="text-right">{{ bill.air_conditioner_price | formatNumber }}</td>
            </tr>
            <tr class="font-weight-bold">
                <td class="text-left text-no-wrap">Thành tiền</td>
                <td class="text-right text-no-wrap">{{ bill.air_conditioner.total_bill | formatNumber }}</td>
            </tr>
        </template>
        <template v-if="bill.internet && bill.internet.total_bill">
            <tr>
                <td class="font-weight-bold" colspan="2">
                    Tiền Internet
                </td>
            </tr>
            <tr
                v-for="(device, index) in bill.internet.data"
                :key="'internet' + index"
            >
                <td class="text-left">-- {{ device.name }} ({{ device.price / 1000}}k)</td>
                <td class="text-right">{{ device.date_count }} ngày</td>
            </tr>
            <tr class="font-weight-bold">
                <td class="text-left text-no-wrap">Thành tiền</td>
                <td class="text-right text-no-wrap">{{ bill.internet.total_bill | formatNumber }}</td>
            </tr>
        </template>
        <tr class="font-weight-bold">
            <td class="text-left">TỔNG CỘNG</td>
            <td class="text-right">{{ bill.total_bill | formatNumber}} ₫</td>
        </tr>
        <tr>
            <td colspan="2">
                <hr>
            </td>
        </tr>
        <tr v-if="bill.debt_amount != 0 && (!bill.debt_details || !bill.debt_details.length)">
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Tiền nợ tháng {{ bill.debt_months && bill.debt_months.toString() }}:</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.debt_amount | formatNumber}} ₫</td>
        </tr>
        <template v-if="bill.debt_amount != 0 && bill.debt_details && bill.debt_details.length">
            <tr
                v-for="debt in bill.debt_details"
                :key="debt.month"
            >
                <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Tiền nợ tháng {{ debt.month }}:</td>
                <td class="text-right text-no-wrap" style="width: 200px">{{ debt.debt_amount | formatNumber}} ₫</td>
            </tr>
        </template>
        <tr>
            <td class="font-weight-bold" colspan="2">
                <hr>
                Số tiền trả trước
            </td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Tiền cọc:</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ (bill.deposit_status ? bill.deposit_price : bill.deposit_amount) | formatNumber }} ₫</td>
        </tr>
        <tr>
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Tiền phòng trả trước:</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ (bill.deposit_status ? bill.room_price : 0) | formatNumber}} ₫</td>
        </tr>
        <tr v-if="other_fine_amount || bill.fine_amount">
            <td class="font-weight-bold" colspan="2">
                <hr>
                Số tiền phạt
            </td>
        </tr>
        <tr v-if="bill.fine_status != 0 && bill.fine_status_text">
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">{{ bill.fine_status_text}}:</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{bill.fine_amount | formatNumber}} ₫</td>
        </tr>
        <tr v-if="other_fine_amount">
            <td class="text-left text-no-wrap font-weight-bold" style="width: 200px">Phạt khác:</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ other_fine_amount | formatNumber}} ₫</td>
        </tr>
        <tr>
            <td colspan="2">
                <hr>
            </td>
        </tr>
        <tr class="font-weight-bold">
            <td class="text-left text-no-wrap" style="width: 200px">Số tiền trả cọc:</td>
            <td class="text-right text-no-wrap" style="width: 200px">{{ bill.amount && Number(bill.amount.toString().replace(" ₫", '').replace(/\./g, '')) | formatNumber}} ₫</td>
        </tr>
    </table>
</div>
</template>
<script>
export default {
    props: {
        bill: Object,
    },
    name: "return-deposit-bill-detail",
    data(){
        return {}
    },
    computed: {
        other_fine_amount(){
            return this.bill.other_fine_amount ? Number(this.bill.other_fine_amount.toString().replace(" ₫", '').replace(/\./g, '')) : 0
        }
    }
}
</script>
<style scoped>
    .font-weight-bold {
        font-weight: 700 !important;
    }
    .font-weight-black {
        font-weight: 900 !important;
    }
    .mx-auto {
        margin: 0 auto;
    }
    .text-center {
        text-align: center;
    }
    .text-right {
    text-align: right;
    }
    .text-no-wrap {
        white-space: nowrap !important;
    }
    .text-left {
        text-align: left;
    }
</style>